import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import NotificationsList from './NotificationsList'

export default function Notifications() {
	return (
		<React.Fragment>
			<Switch>
				<Route exact path="/notifications" component={NotificationsList} />

				<Redirect to="/404" />
			</Switch>
		</React.Fragment>
	)
}